<template>
  <div class="px-2 pb-2">
    <VueCustomTooltip position="is-bottom" class="w-full" :label="tooltip || t( 'Please complete this field.' )" sticky :active="show_required">
      <InputStd ref='input_std' type='text' name="value" :readonly="readonly" v-model="val" @input="$emit('update:modelValue', $event.target.value);$emit('change', $event.target.value)"></InputStd>
    </VueCustomTooltip>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import InputStd from './InputStd.vue';

export default {
  name: 'input-text-required-component',
  components: {
    InputStd
  },
  props: {
    modelValue: { String, required: true },
    readonly: { Boolean, required: false, default: false },
    show_required: { Boolean, required: false, default: false },
    tooltip: { String, required: false, default: '' }
  },
  emit: [ 'change' ],
  setup( props ) {
    const { t } = useI18n();
    const input_std = ref ( null );
    const val = ref( props.modelValue );

    const focus = () => {
      input_std.value.focus();
    };

    return { t, input_std, val, focus };
  }
};
</script>
